'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = exports.duration = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $animationDurationMap = _require.$animationDurationMap;
// Duration function
// -----------------------------------------------------------------------------
// =============================================================================
// ANIMATION (Settings)
// =============================================================================


var duration = exports.duration = (0, _dictionary2.default)($animationDurationMap, 'Unknown duration used in duration function');
// Delay function
// -----------------------------------------------------------------------------
var delay = exports.delay = (0, _dictionary2.default)($animationDurationMap, 'Unknown delay used in delay function');
//# sourceMappingURL=animation.js.map